import React from 'react';
import { Link } from 'react-router-dom';
import { getDomain } from '../utils/getDomain';
import {
  COMPANY_ADDRESS_LINE1,
  COMPANY_ADDRESS_LINE2,
  COMPANY_NAME,
} from '../constants/company';

function Footer() {
  const domain = getDomain();
  const contactEmail = `contact@${domain}`;
  
  return (
    <footer>
      <div className="container">
        <div className="widget-footer">
          <h4>Links</h4>
          <ul>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/tos">Terms of Service</a></li>
          </ul>
        </div>
        <div className="widget-footer company-widget">
          <h4>Company</h4>
          <p className="footer-company-address">
            {COMPANY_NAME}
            <br />
            {COMPANY_ADDRESS_LINE1}
            <br />
            {COMPANY_ADDRESS_LINE2}
          </p>
        </div>
        <div className="widget-footer">
          <h4>Contact Us</h4>
          <ul>
            <li><a href={`mailto:${contactEmail}`}>{contactEmail}</a></li>
          </ul>
        </div>
        <div className="widget-footer last">
          <Link to="/"><img src="/images/logo.svg" alt="logo" style={{ height: '48px', width: '48px' }} /></Link>
          <p className="footer-tagline">Private. Anonymous. Secure.</p>
        </div>
        <div className="copyright">
          <p>&copy; Copyright {new Date().getFullYear()} {COMPANY_NAME}, All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
